export {
  getTokenData,
  removeAuthCookie,
  setAuthCookie,
} from "./CookiesService";
